export const TestId = {
  HOVER_ACTIONS_COPY: 'HoverActionCopy',
  HOVER_ACTIONS_DELETE: 'HoverActionDelete',
  HOVER_ACTIONS_EDIT: 'HoverActionEdit',
  HOVER_ACTIONS: 'HoverActions',
};
